import { render, staticRenderFns } from "./BusinessWall.vue?vue&type=template&id=e300e43a&"
import script from "./BusinessWall.vue?vue&type=script&lang=js&"
export * from "./BusinessWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports